import { maskAbhaAddress, maskAbhaNumber } from '../services/api/abhaProfile';
import { SCAN_SHARE_COPY } from '../constants/abdmCopy';

/** Scan & Share (R56) helpers shared by the waiting panel and the two registration surfaces. */

/** Plain-words reason for a failed claim (contract codes from POST /abha/scan-share/claim). */
const CLAIM_MESSAGES = {
  SCAN_ALREADY_CLAIMED: 'This scan was already used for another patient.',
  ABHA_ALREADY_LINKED: 'This ABHA is already linked to another patient.',
  SCAN_SHARE_EXISTING_PATIENT: 'This patient already exists, so the scan was not linked automatically. ' + SCAN_SHARE_COPY.verifyInstead,
  NO_PENDING_SCAN: 'This scan is no longer waiting.',
  SCAN_GONE: 'This scan has expired or cannot be used. Ask the patient to scan again.',
};

export function claimErrorMessage(err) {
  return CLAIM_MESSAGES[err?.abhaCode] || err?.message || 'Please try again.';
}

/** Shown up front when a picked scan's mobile belongs to an already-registered patient (the claim is never tried). */
export const EXISTING_PATIENT_VERIFY_NOTICE =
  'This patient is already registered. Verify their ABHA with an OTP. ABDM will send it to their phone.';

/** Snapshot handed to the OPD / admission form from a revealed scan (carries the scan_id to claim). */
export function scanSnapshot(full, scanId, masked = '') {
  return {
    fullName: full.name,
    gender: full.gender,
    yearOfBirth: full.yearOfBirth,
    mobile: full.mobile,
    registrationMobile: full.mobile,
    abhaAddress: 'Scan & Share profile',
    abhaMasked: masked,
    scanId,
  };
}

/** Text after "ABHA ready to link:" - always MASKED (R123): the scan's masked ABHA address/number, never the full value. */
export function abhaReadyLabel(snap) {
  if (snap?.scanId) return snap.abhaMasked ? `${snap.abhaMasked} (Scan & Share)` : 'Scan & Share profile';
  return snap?.abhaAddress ? maskAbhaAddress(snap.abhaAddress) : maskAbhaNumber(snap?.abhaNumber);
}
